import { FormikHelpers } from "formik";

export const displayErrorInField = <T,>(
  formikActions: FormikHelpers<T>,
  fieldName: string,
  message: string,
): void => {
  formikActions.setFieldTouched(fieldName, true, false);
  formikActions.setFieldError(fieldName, message);
};
